import { css } from 'styled-components';

// The inset highlight the nav and page header edge their surfaces with, in place of a stroke.
// It rides an overlay: an inset shadow paints under the content, so a panel whose children
// fill their own background (a header, a list, an input bar) would hide it.
export const insetHighlight = css`
	position: relative;

	&::after {
		content: '';
		position: absolute;
		inset: 0;
		border-radius: inherit;
		box-shadow: ${props => props.theme.shadow.inset};
		pointer-events: none;
	}
`;
